import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  EnterOutlined,
} from '@ant-design/icons'
import { Space, Tag, Typography } from 'antd'

const { Text } = Typography

const SearchDialogModalFooter = () => (
  <Space size={25}>
    <Text type="secondary">
      <Tag>
        <ArrowUpOutlined />
      </Tag>
      <Tag>
        <ArrowDownOutlined />
      </Tag>
      to navigate
    </Text>
    <Text type="secondary">
      <Tag>
        <EnterOutlined />
      </Tag>
      to select
    </Text>
    <Text type="secondary">
      <Tag>esc</Tag>to close
    </Text>
  </Space>
)

export default SearchDialogModalFooter
